/**
 * Mobile PDP gallery: syncs the plain scroll-row thumbnails with the Swiper Element
 * main gallery (.mobile-gallery-swiper), and keeps the wishlist heart overlaid on
 * whichever slide is currently active — not just the first.
 *
 * The thumbnail row is not a second Swiper instance — figma's thumbnail row is a
 * simple horizontal strip, not a paginated carousel — so that part is just
 * click-to-slide + active-state highlighting.
 *
 * The wishlist slot (.pdp-wishlist-slot--mobile) is a live DOM node, not duplicated
 * per slide: it's physically moved into whichever <swiper-slide> is active. Swym's
 * real button lives inside that same node (relocated there separately by
 * swym-wishlist.js), so it travels along automatically — no need to touch that file.
 * swiper-slide has position:relative (styles.css.liquid) so the slot's top/right
 * positioning is always relative to the CURRENT slide's own box, regardless of the
 * peek layout's per-slide width.
 */
(function () {
  function initGallery(gallery) {
    var swiperEl = gallery.querySelector('.mobile-gallery-swiper');
    if (!swiperEl) return;

    var thumbs = gallery.querySelectorAll('.mobile-gallery-thumbnail');
    var wishlistSlot = gallery.querySelector('.pdp-wishlist-slot--mobile');

    function setActiveThumb(index) {
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
    }

    function moveWishlistSlot(index) {
      if (!wishlistSlot) return;
      var slides = swiperEl.querySelectorAll('swiper-slide');
      var targetSlide = slides[index];
      if (targetSlide && !targetSlide.contains(wishlistSlot)) {
        targetSlide.appendChild(wishlistSlot);
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = Number(thumb.dataset.slideIndex);
        if (swiperEl.swiper) swiperEl.swiper.slideTo(index);
        setActiveThumb(index);
        moveWishlistSlot(index);
      });
    });

    // Swiper Element dispatches this on the host element itself (not bubbled from
    // inside its shadow root), so a plain listener here is sufficient. Covers swipe
    // gestures, not just thumbnail clicks.
    swiperEl.addEventListener('swiperslidechange', function () {
      if (!swiperEl.swiper) return;
      setActiveThumb(swiperEl.swiper.activeIndex);
      moveWishlistSlot(swiperEl.swiper.activeIndex);
    });
  }

  document.querySelectorAll('.gallery').forEach(initGallery);

  // Re-init for sections loaded after the initial page render (theme editor, quickbuy).
  document.addEventListener('shopify:section:load', function (e) {
    var gallery = e.target.querySelector && e.target.querySelector('.gallery');
    if (gallery) initGallery(gallery);
  });
})();
